import request from "@/utils/request";

// happy公司支付
export function payerMaxPay(query) {
  return request({
    url: '/payCoupon/order/fixedPayment',
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'post',
	data: query
  })
}
// enjoy公司支付
export function enjoyPay(query) {
  return request({
    url: '/payCoupon/order/enjoyFixedPayment',
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'post',
	data: query
  })
}
// UGame公司支付
export function ugamePay(query) {
  return request({
    url: '/payCoupon/order/uGameFixedPayment',
    headers: {
      isToken: true,
      isMallApi: true
    },
    method: 'post',
	data: query
  })
}
// 订单状态查询
export function happyPayStatus(orderId) {
  return request({
    url: '/gmVerify/'+orderId,
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'get'
  })
}
// 订单状态查询
export function enjoyPayStatus(orderId) {
  return request({
    url: '/enjoy/gmVerify/'+orderId,
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'get'
  })
}
// 订单状态查询
export function ugamePayStatus(orderId) {
  return request({
    url: '/uGame/gmVerify/'+orderId,
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'get'
  })
}
// 订单中心列表
export function getOrders(data) {
  return request({
    url: '/user/order/list',
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'get',
	params: data
  })
}
// 订单中心合计
export function getOrdersSum(data) {
  return request({
    url: '/user/order/paySum',
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'get',
	params: data
  })
}
// 游戏筛选
export function getOrdersGame(query) {
  return request({
    url: '/user/order/userGame',
    headers: {
      isToken: true,
	  isMallApi: true
    },
    method: 'get',
	params: query
  })
}